import { render, staticRenderFns } from "./ClaimSACEvolution.vue?vue&type=template&id=2c6eb922&scoped=true&lang=pug"
import script from "./ClaimSACEvolution.vue?vue&type=script&lang=js"
export * from "./ClaimSACEvolution.vue?vue&type=script&lang=js"
import style0 from "./ClaimSACEvolution.vue?vue&type=style&index=0&id=2c6eb922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6eb922",
  null
  
)

export default component.exports